import React from 'react'
import PropTypes from 'prop-types'

const FlyoutContainer = ({ className, children, innerClassName }) => {
  return (
    <div className={className}>
      <div
        className={`
          px-16 pt-24 pb-40 bg-ffffff
          grid grid-cols-1 auto-rows-min
          transition-all duration-350 ease-in
          fixed left-0 right-0 top-64 bottom-0
          overflow-scroll

          600:top-80
          720:px-24 720:pt-32

          840:px-0 840:py-0
          840:static 840:top-auto
          840:overflow-visible
          840:grid-cols-none
          ${innerClassName}
        `}
      >
        {children}
      </div>
    </div>
  )
}

FlyoutContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  innerClassName: PropTypes.string,
}

FlyoutContainer.defaultProps = {
  className: '',
  innerClassName: '',
}

export default FlyoutContainer
